import * as yup from "yup";
import { DoubleMaterialityValueChainPart } from "@green0meter/api-client";

export const validationSchema = yup.object().shape({
  assessmentId: yup.string().required("Assessment ID is required"),
  year: yup
    .number()
    .required("Year is required")
    .min(2020, "Year must be at least 2020"),
  topic: yup.number().required("Topic is required"),
  subTopic: yup.string().nullable(),
  subSubTopic: yup.string().nullable(),
  partOfValueChain: yup
    .array()
    .of(yup.mixed<DoubleMaterialityValueChainPart>().required())
    .required()
    .min(1, "At least one part of value chain is required"),
  relevantSubjects: yup.array().of(yup.string().required()).required(),
  sustainabilityMatter: yup.string().required("Sustainability matter is required"),
  impacts: yup.string().nullable(),
  risks: yup.string().nullable(),
  opportunities: yup.string().nullable(),
  sources: yup.string().nullable(),
  attachments: yup.array().of(yup.mixed()).default([]),
});
